export const toDate = (dateOrTimestamp) => {
  if(!dateOrTimestamp || (typeof dateOrTimestamp === 'string')) return null
  if(dateOrTimestamp.seconds) return new Date(dateOrTimestamp.seconds*1000)
  return dateOrTimestamp
}

export const toDateHuman = (dateOrTimestamp) => {
  const date = toDate(dateOrTimestamp)
  if(!date) return dateOrTimestamp
  return `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}`
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/share/date_helper.js